(() => {
  let lastTrigger;

  document.addEventListener('click', (event) => {
    if (event.target.matches('.pdp-zoom-trigger')) lastTrigger = event.target;
  }, true);

  document.addEventListener('keydown', (event) => {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('.pdp-zoom-trigger')) {
      event.preventDefault();
      lastTrigger = event.target;
      event.target.onclick.call(event.target, {
        isTrusted: true,
        preventDefault() {},
        stopPropagation() {},
      });
    }
  });

  function restoreFocus(dialog) {
    const trigger = dialog.__zoomTrigger || lastTrigger;
    window.setTimeout(() => {
      if (trigger && document.contains(trigger)) trigger.focus();
    });
  }

  function trapFocus(event, dialog) {
    if (event.key !== 'Tab') return;

    const focusable = Array.from(
      dialog.querySelectorAll('button:not([hidden]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
    ).filter((element) => !element.disabled && !element.hidden && element.getClientRects().length > 0);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function initialiseDialog(dialog) {
    if (dialog.dataset.accessibilityReady) return;

    dialog.dataset.accessibilityReady = 'true';
    dialog.__zoomTrigger = lastTrigger;
    dialog.setAttribute('aria-label', 'Image zoom');
    dialog.addEventListener('keydown', (event) => trapFocus(event, dialog));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-zoom-close]')) restoreFocus(dialog);
    }, true);
  }

  new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE && node.matches('[data-pdp-click-zoom]')) initialiseDialog(node);
      });
      record.removedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE && node.matches('[data-pdp-click-zoom]')) restoreFocus(node);
      });
    });
  }).observe(document.body, { childList: true });
})();
